import React from 'react';
import { Box } from '@spothero/ui';
import UrlUtils from '@spothero/utils/url';
import SpotListSorter from 'common/search-sort-controls';
import { useSelector } from 'react-redux';
import { SPOT_SORT_OPTIONS } from 'utils/spot-sort';
import { ViewUpcomingEventsList } from './view-upcoming-events-list/ViewUpcomingEventsList';
import { MonthlyHelp } from './monthly-help/MonthlyHelp';
import { MobileFilterCallouts } from './filter-callouts/mobile/MobileFilterCallouts';
import { showVehicleTooltip } from 'common/utils';
import { getParkingType } from 'store/selectors/selectors';
// Ideally we shift to this being the home of everything in between search component and the actual list
export const PreSpots = ({ showSpotListSorter, onChangeSort, showMobileToggle, VerticalPromo, }) => {
    const sortBy = useSelector((state) => state.search.data.sortBy);
    const spots = useSelector((state) => state.spots.data);
    const parkingType = useSelector(getParkingType);
    const isAirport = parkingType === 'airport';
    const showMissingVehicleTooltip = showVehicleTooltip(spots);
    const { operator_id: operatorId } = typeof window === 'undefined'
        ? ''
        : UrlUtils.parseParams(window.location.search);
    const sortSelectItems = [
        {
            value: isAirport
                ? SPOT_SORT_OPTIONS.FEATURED
                : SPOT_SORT_OPTIONS.RELEVANCE,
            label: 'Sort by Relevance',
        },
        {
            value: SPOT_SORT_OPTIONS.DISTANCE,
            label: 'Sort by Distance',
        },
        { value: SPOT_SORT_OPTIONS.PRICE, label: 'Sort by Price' },
    ];
    const airportSortOption = {
        value: SPOT_SORT_OPTIONS.SHUTTLE_TIME,
        label: 'Sort by Shuttle Duration',
    };
    if (isAirport) {
        sortSelectItems.push(airportSortOption);
    }
    return (<Box data-testid="preSpotList">
            <MobileFilterCallouts showMissingVehicleTooltip={showMissingVehicleTooltip}/>
            <ViewUpcomingEventsList />
            <MonthlyHelp />
            {showSpotListSorter ? (<Box sx={{
                '.SpotListSorter': {
                    marginTop: 2,
                    marginBottom: 3,
                    padding: 0,
                },
                '.SpotListSorter-text': {
                    marginTop: 2,
                    marginBottom: 3,
                    padding: 0,
                },
            }}>
                    <SpotListSorter operatorId={operatorId} numberOfSpots={spots.length} sortBy={sortBy} 
        // @ts-expect-error - to fix
        onChangeSort={({ value }) => onChangeSort(value)} sortSelectItems={sortSelectItems} showMobileToggle={showMobileToggle}/>
                </Box>) : null}
            {VerticalPromo}
        </Box>);
};
